import { Injectable } from "@angular/core";
import { ApiService } from "../http/api.service";
import { ApiPath } from "../models/api-path";
import { AdobeModel } from "../models/shared/commone.model";
declare global { interface Window { AdobeDC: any; } }
@Injectable({
    providedIn: 'root'
})
export class ViewSDKClient {
    constructor(
        private apiService: ApiService
    ) {

    }
    pdfRef: any;

    readyPromise: Promise<void> = new Promise((resolve) => {
        if (window.AdobeDC) {
            resolve();
        } else {
            /* Wait for Adobe Document Services PDF Embed API to be ready */
            document.addEventListener('adobe_dc_view_sdk.ready', () => {
                resolve();
            });
        }
    });
    adobeDCView: any;
    ready() {
        return this.readyPromise;
    }
    async GetAdobeEmbedAPIKey(): Promise<string> {
        const result = await this.apiService.get<AdobeModel>(`${ApiPath.setting.base}/license/adobe-dc`);
        return result!.licenseKey;
    }

    async previewFile(divId: string, viewerConfig: any, fileName: string, titleName: string) {
        const config: any = {
            /* Pass your registered client id */
            clientId: await this.GetAdobeEmbedAPIKey() // we can import from environment file
        };
        if (divId) { /* Optional only for Light Box embed mode */
            /* Pass the div id in which PDF should be rendered */
            config.divId = divId;
        }
        /* Initialize the AdobeDC View object */
        this.adobeDCView = new window.AdobeDC.View(config);
        /* Invoke the file preview API on Adobe DC View object */
        this.adobeDCView.previewFile({
            /* Pass information on how to access the file */
            content: {
                /* Location of file where it is hosted */
                location: {
                    url: fileName, // pdf file,
                    /*
                    If the file URL requires some additional headers, then it can be passed as follows:-
                    headers: [
                        {
                            key: '<HEADER_KEY>',
                            value: '<HEADER_VALUE>',
                        }
                    ]
                    */
                },
            },
            /* Pass meta data of file */
            metaData: {
                /* file name */
                fileName: titleName ? titleName : ' ',
                /* file ID */
                id: 'mmy file id'
            }
        }, viewerConfig);
    }
}



 